import { FC } from 'react';
import SvgIcon from '../SvgIcon/SvgIcon';
import styles from './SettingsItem.module.scss';

interface Props {
	icon: string;
	label: string;
	actionIcon: string;
	externalUrl?: string;
	action?: () => void;
}

const SettingsItem: FC<Props> = ({ icon, label, actionIcon, externalUrl, action }) => {
	const actionButton = externalUrl ? (
		<a href={externalUrl} target="_blank" rel="noopener noreferrer" aria-label={label}>
			<SvgIcon className={styles.actionIcon} src={actionIcon} />
		</a>
	) : (
		<SvgIcon className={styles.actionIcon} src={actionIcon} onClick={action} />
	);

	return (
		<div className={styles.settingsItem}>
			<div className={styles.settingsTitle}>
				<SvgIcon className={styles.settingsIcon} src={icon} />
				{label}
			</div>
			{actionButton}
		</div>
	);
};

export default SettingsItem;
